import { useQuery } from '@apollo/client';
import { toUpper } from 'lodash';
import { isServer } from '@app/utils';
import FETCH_CUSTOMER_ASKS_FOR_PRODUCT from '@drc/pages/Product/shared/components/CustomerActivity/queries/FetchCustomerAsksForProduct';
import FETCH_CUSTOMER_BIDS_FOR_PRODUCT from '@drc/pages/Product/shared/components/CustomerActivity/queries/FetchCustomerBidsForProduct';

const getDataFromQuery = (data, type) => {
  if (type === 'ask') {
    return data?.variantAsk?.asks?.edges?.[0]?.node;
  }

  return data?.variantBid?.bids?.edges?.[0]?.node;
};

const useCustomerBidOrAsk = (
  customer,
  currencyCode,
  getProductIdVar,
  isVariant,
  type,
  amount,
) => {
  const skipQuery = !getProductIdVar || !customer || amount;
  const query =
    type === 'ask'
      ? FETCH_CUSTOMER_ASKS_FOR_PRODUCT
      : FETCH_CUSTOMER_BIDS_FOR_PRODUCT;

  const { data, loading, error } = useQuery(query, {
    variables: {
      productId: getProductIdVar,
      currencyCode: toUpper(currencyCode),
      isVariant,
    },
    skip: skipQuery,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: isServer ? 'cache-only' : 'cache-and-network',
  });

  const res = amount
    ? {
        __typename: type === 'ask' ? 'Ask' : 'Bid',
        id: getProductIdVar,
        amount,
      }
    : getDataFromQuery(data, type);

  return { res, loading, error };
};

export default useCustomerBidOrAsk;
